<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item" v-if="uRole=='Customer'">
        <sidenav-item
          @click="toggleSidebar"
          url="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Inicio'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="uRole=='Customer'">
        <sidenav-item
          @click="toggleSidebar"
          url="/contracts"
          :class="getRoute() === 'contracts' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Contratos'"
        >
          <template v-slot:icon>
            <i class="ni ni-paper-diploma text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      
      <!-- <li class="nav-item">
        <sidenav-item
          @click="toggleSidebar"
          url="/campaigns"
          :class="getRoute() === 'campaigns' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Ejecuciones'"
        >
          <template v-slot:icon>
            <i class="ni ni-paper-diploma text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="nav-item" v-if="uRole=='Customer'">
        <sidenav-item
          @click="toggleSidebar"
          url="/installs"
          :class="getRoute() === 'installs' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Instalaciones'"
        >
          <template v-slot:icon>
            <i class="ni ni-settings text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item" v-if="uRole=='Customer'">
        <sidenav-item
          @click="toggleSidebar"
          url="/photo-report"
          :class="getRoute() === 'photo-report' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Reporte Fotográfico'"
        >
          <template v-slot:icon>
            <i class="fa fa-camera text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="uRole=='Salesforce'">
        <sidenav-item
          @click="toggleSidebar"
          url="/dashboard-sf"
          :class="getRoute() === 'dashboard-sf' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Inicio'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="uRole=='Salesforce'">
        <sidenav-item
          @click="toggleSidebar"
          url="/contracts-sf"
          :class="getRoute() === 'contracts-sf' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Contratos por ejecutivo'"
        >
          <template v-slot:icon>
            <i class="ni ni-paper-diploma text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item" v-if="uRole=='Salesforce'">
        <sidenav-item
          @click="toggleSidebar"
          url="/installs-sf"
          :class="getRoute() === 'installs-sf' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Instalaciones por ejecutivo'"
        >
          <template v-slot:icon>
            <i class="ni ni-settings text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item" v-if="uRole=='Salesforce'">
        <sidenav-item
          @click="toggleSidebar"
          url="/photo-report-sf"
          :class="getRoute() === 'photo-report-sf' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Reporte Fotográfico Ejecutivo'"
        >
          <template v-slot:icon>
            <i class="fa fa-camera text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="uRole=='Account Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/dashboard-sfa"
          :class="getRoute() === 'dashboard-sfa' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Inicio'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="uRole=='Account Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/contracts-sfa"
          :class="getRoute() === 'contracts-sfa' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Contratos'"
        >
          <template v-slot:icon>
            <i class="ni ni-paper-diploma text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item" v-if="uRole=='Account Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/installs-sfa"
          :class="getRoute() === 'installs-sfa' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Instalaciones'"
        >
          <template v-slot:icon>
            <i class="ni ni-settings text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item" v-if="uRole=='Account Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/photo-report-sfa"
          :class="getRoute() === 'photo-report-sfa' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Reporte Fotográfico'"
        >
          <template v-slot:icon>
            <i class="fa fa-camera text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="uRole=='Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/dashboard-sfm"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Inicio'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="uRole=='Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/contracts-sfm"
          :class="getRoute() === 'contracts-sfm' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Contratos'"
        >
          <template v-slot:icon>
            <i class="ni ni-paper-diploma text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item" v-if="uRole=='Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/installs-sfm"
          :class="getRoute() === 'installs-sfm' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Instalaciones'"
        >
          <template v-slot:icon>
            <i class="ni ni-settings text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item" v-if="uRole=='Manager'">
        <sidenav-item
          @click="toggleSidebar"
          url="/photo-report-sfm"
          :class="getRoute() === 'photo-report-sfm' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Reporte Fotográfico'"
        >
          <template v-slot:icon>
            <i class="fa fa-camera text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <li class="nav-item" v-if="uRole=='Admin'">
        <sidenav-item
          @click="toggleSidebar"
          url="/users"
          :class="getRoute() === 'photo-report' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Usuarios'"
        >
          <template v-slot:icon>
            <i class="fa fa-user text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          @click="toggleSidebar"
          url="/my-profile"
          :class="getRoute() === 'my-profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Perfil'"
        >
          <template v-slot:icon>
            <i class="fa fa-user text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- <li class="nav-item">
        <sidenav-item
          url="/cases"
          :class="getRoute() === 'cases' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Casos'"
        >
          <template v-slot:icon>
            <i class="ni ni-notification-70 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item">
        <sidenav-item
          url="/signin"
          @click="logout"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Salir'"
        >
          <template v-slot:icon>
            <i class="fa fa-sign-out text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="mt-3 nav-item">
        <h6
          v-if="this.$store.state.isRTL"
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          صفحات المرافق
        </h6>
        <h6
          v-else
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          AJUSTES
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'حساب تعريفي' : 'Perfil'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";
import { mapMutations } from "vuex";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      uRole:localStorage.getItem('Role')
    };
  },
  components: {
    SidenavItem,
    SidenavCard
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout(){
      this.toggleSidebar(); 
      localStorage.clear();
    },
    toggleSidebar() {
      this.navbarMinimize();
    }
  }
};
</script>
